import { useWhiteLabelContext } from 'components/white-label';
import { getIsProduction } from 'lib/helpers/envHelper';
import { Organization } from 'lib/types/company';
import Script from 'next/script';

export const HotJarTracker = () => {
  const { organization } = useWhiteLabelContext();
  const isProduction = getIsProduction();
  return (
    organization === Organization.LIFE_LABS &&
    isProduction && (
      <Script id="hotjar-lifelabs" strategy="afterInteractive">
        {`(function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:5248058,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src='https://' + t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
          a.appendChild(r);
        })(window,document,'static.hotjar.com/c/hotjar-','.js?sv=');`}
      </Script>
    )
  );
};
